import React from "react"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"
import BackgroundImage from 'gatsby-background-image'

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import Header from "./../../../components/header"
import ListItem from "./../../../components/ListItem"
import BadgeItem from "./../../../components/BadgeItem"
import BackButton from "./../../../components/BackButton"
import Album from "./../../../components/Album"

export default function AnEostig({ data }) {
  return (
    <Layout>
      <Header title="Retour" href="/estacades" />
      <SEO title="An Eostig" />

      <BackgroundImage
        className="banner"
        fluid={[
          'linear-gradient(transparent, #101010 90%)',
          data.bg.childImageSharp.fluid,
        ]}
      >
        <h1>An Eostig</h1>
      </BackgroundImage>

      <p>
        La chaloupe An Eostig a été construite dans le cadre du concours des « bateaux des côtes de France ». Mise à l’eau lors des Fêtes maritimes de 1992, cette grande chaloupe sardinière semi-pontée reproduit à l’identique les chaloupes construites après les crises de la sardine du début du XXe siècle : plus robustes et taillées pour la haute mer, elles permettent de diversifier la pêche quand la sardine vient à manquer.
      </p>

      <Album slides={data.photos} />

      <BackButton />

    </Layout>
  )
}

export const query = graphql`
  query {
    bg: file(relativePath: { eq: "estacades/an-eostig/an-eostig.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    photos: allFile(
      filter: {relativeDirectory: {regex: "/estacades/an-eostig/photos/"}},
      sort: {fields: name}
    ) {
      edges {
        node {
          id
          childImageSharp {
            fluid(maxWidth: 360) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
